import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { Feature, MultiPolygon, Polygon } from 'geojson';
import { DeclareMethod } from '/imports/methods';

export interface Apn extends Feature<MultiPolygon | Polygon> {
  _id: string;
  properties: {
    OBJECTID: number;
    PARCEL_APN: string;
    FIPS_CODE: string;
    PARCEL_DMP_ID: string;
    COUNTYNAME: string;
    SITE_ADDR: string;
    SITE_CITY: string;
    SITE_STATE: string;
    SITE_ZIP: string;
    SITE_PLUS_4: string;
    SITE_UNIT_PREFIX: string;
    SITE_UNIT_NUMBER: string;
    SITE_HOUSE_NUMBER: string;
    SITE_DIRECTION: string;
    SITE_STREET_NAME: string;
    SITE_MODE: string;
    SITE_QUADRANT: string;
    FullStreetAddress: string;
    Search_PARCELAPN: string;
    Shape__Area: number;
    Shape__Length: number;
    fractint: number;
    asr_total: number;
    overlay_juris: string;
    parcelid: number;
    multi: string;
    apn_8: string;
    situs_building: null;
    legldesc: string;
    situs_pre_dir: string;
    docdate: string;
    apn: string;
    garage_stalls: string;
    acreage: number | null;
    pool: string;
    total_lvg_area: number;
    situs_suite: string;
    bedrooms: string;
    asr_zone: number;
    situs_juris: string;
    situs_street: string;
    asr_impr: number;
    par_view: string;
    y_coord: number;
    situs_post_dir: string;
    situs_community: string;
    SHAPE__Length: number;
    addition_area: number;
    submap: string;
    year_effective: string;
    x_coord: number;
    situs_zip: string;
    nucleus_situs_thru_fractn: string;
    situs_fraction: string;
    nucleus_zone_cd: string;
    sub_type: number;
    taxstat: string;
    carport_stalls: string;
    nucleus_use_cd: string;
    ownerocc: string;
    qual_class_shape: string;
    unitqty: number;
    SHAPE__Area: number;
    usable_sq_feet: string;
    tranum: string;
    subname: string;
    situs_suffix: string;
    nucleus_situs_from_nbr: number;
    asr_landuse: number;
    doctype: string;
    baths: string;
    nucleus_situs_thru_nbr: number;
    docnmbr: string;
    objectid: number;
    situs_address: number;
    asr_land: number;
    garage_conversion: string;
  };
  altGeometry?: Feature<MultiPolygon | Polygon>['geometry'];
  area?: number;
  centroid?: number[];
  footprintIds?: string[];
  numFootprints?: number;
}

export const Apns = new Mongo.Collection<Apn>('apns');

export interface ApnEnrichment {
  _id: string;
  geometryKey: string;
  apns: Apn[];
  createdAt: Date;
}

export const ApnEnrichments = new Mongo.Collection<ApnEnrichment>('apnEnrichments');

export const listApnsInPolygon = DeclareMethod<{ polygon: Polygon }, Apn[]>('listApnsInPolygon');

export const asrZoneMap: { [key: number]: string } = {
  0: 'UNZONED',
  1: 'SINGLE FAMILY RESIDENTIAL',
  2: 'MINOR MULTIPLE',
  3: 'RESTRICTED MULTIPLE',
  4: 'MULTIPLE RESIDENTIAL',
  5: 'RESTRICTED COMMERCIAL',
  6: 'COMMERCIAL',
  7: 'INDUSTRIAL',
  8: 'AGRICULTURAL',
  9: 'SPECIAL AND/OR MISC.',
};

Meteor.isServer && Meteor.startup(async () => {
  await Apns.createIndexAsync({ geometry: '2dsphere' });
  await Apns.createIndexAsync({ 'properties.PARCEL_APN': 1 });
  await Apns.createIndexAsync({ 'properties.Search_PARCELAPN': 1 });
  await Apns.createIndexAsync({ 'properties.Shape__Area': 1 });
  await ApnEnrichments.createIndexAsync({ geometryKey: 1 }, { unique: true });
});
